import createAsyncActionType from '../../../utilities/createAsyncActionType';

// CLEAR
export const CLEAR_CLIENT_PROFILE_ENTRY_STATUS = 'CLEAR_CLIENT_PROFILE_ENTRY_STATUS';
export const CHANGE_CLIENT_PROFILE_ENTRY_STATUS = createAsyncActionType('CHANGE_CLIENT_PROFILE_ENTRY_STATUS');



// WEBPACK FOOTER //
// ./src/features/client-profile/types/clientProfileEntryStatus.js